import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PinDropIcon from '@mui/icons-material/PinDrop';
import WorkIcon from '@mui/icons-material/Work';

export const getIconByType = (type, currColor, size = 16) => {
  switch (type) {
    case 'phone':
      return <LocalPhoneIcon sx={{ color: currColor, width: `${size}px`, height: `${size}px` }} />;
    case 'email':
      return <EmailIcon sx={{ color: currColor, width: `${size}px`, height: `${size}px` }} />;
    case 'website':
      return <LanguageIcon sx={{ color: currColor, width: `${size}px`, height: `${size}px` }} />;
    case 'geo':
      return <PinDropIcon sx={{ color: currColor, width: `${size}px`, height: `${size}px` }} />;
    case 'work':
      return <WorkIcon sx={{ color: currColor, width: `${size}px`, height: `${size}px` }} />;
    default:
      return <PinDropIcon sx={{ color: currColor, width: `${size}px`, height: `${size}px` }} />;
  }
};

export const getTitleIconByType = (type) => {
  switch (type) {
    case 'phone':
      return 'headerPhone';
    case 'email':
      return 'headerEmail';
    case 'geo':
      return 'headerLocation';
    default:
      return '';
  }
};

export const getPositionFlex = (position) => {
  switch (position) {
    case 'left':
      return 'flex-start';
    case 'right':
      return 'flex-end';
    case 'center':
      return 'center';
    default:
      return 'center';
  }
};
